import { ConversationMessage, QuickAction } from "@lupp/shared";

export const initialMessages: ConversationMessage[] = [];

export const quickActions: QuickAction[] = [
  { id: "qa-1", title: "Zusammenfassen", prompt: "Fasse den markierten Abschnitt prägnant zusammen." },
  { id: "qa-2", title: "Umformulieren", prompt: "Formuliere den letzten Absatz juristisch präziser um." },
  { id: "qa-3", title: "Offene Punkte", prompt: "Welche offenen Punkte erkennst du in diesem Dokument?" },
];
